import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Flex,
  FlexboxProps,
  Heading,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { ReactNode, useEffect, useState } from 'react';
import Card from 'components/Card';
import { Pie, PieChart, ResponsiveContainer, Tooltip, Cell } from 'recharts';
import { Props as ChartDataProps } from 'components/DonutChart';
import { DonutChart, BarChart } from 'components';

interface ChartCardProps {
  heading?: string;
  variant: 'donut' | 'bar';
}

type Props = ChartCardProps & FlexboxProps & ChartDataProps;

const ChartCard: React.FC<Props> = ({
  heading,
  data,
  variant = 'donut',
}: Props) => {
  return (
    <Card p={2}>
      {heading && (
        <Heading as="h3" mx={4} mt={5} fontWeight="600" fontSize="19px" mb={4}>
          {heading}
        </Heading>
      )}
      {data && (
        <>
          {
            {
              donut: <DonutChart data={data} />,
              bar: <BarChart data={data} />,
            }[variant]
          }
        </>
      )}
    </Card>
  );
};

export default ChartCard;
